var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"iconSpan"},[_c('b-icon',{ref:"deleteToolTip",attrs:{"icon":"trash"},on:{"click":_vm.deleteItem}}),_c('b-tooltip',{attrs:{"target":() => _vm.$refs['deleteToolTip'],"title":_vm.$g('icon.deleteToolTip'),"boundary":"window","container":_vm.uid,"placement":"bottomleft","triggers":"hover"}}),_c('div',{attrs:{"id":_vm.uid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }